import * as React from 'react';
import { useSelector } from 'react-redux';
import { CPDAsideTrapContainer } from 'shared/containers/valuationTraps/CPDTrapContainer/CPDAsideTrap/CPDAsideTrapContainer';
import { isNewbuildingSelector, selectIsAgent, selectIsOfferOwnedByUser } from 'shared/selectors';
import { selectIsCpdAvailable } from 'shared/selectors/cpd/cpd';

export const AsideTrapContainerLoader: React.FC = () => {
  const isCpdAvailable = useSelector(selectIsCpdAvailable);

  const isAgent = useSelector(selectIsAgent);
  const isOfferByUser = useSelector(selectIsOfferOwnedByUser);
  const isNewbuilding = useSelector(isNewbuildingSelector);

  const offerApprovedForCpd = isCpdAvailable && !isNewbuilding && !isOfferByUser && !isAgent;

  if (offerApprovedForCpd) {
    return <CPDAsideTrapContainer />;
  }

  return null;
};
